import type { AnsweringSubjectsResponse } from "@repo/shared/types";
import { get } from "../_client";

const BASE = "/internal/flow-instances";

/**
 * QL-505 (S5 contract) — who answers the product-assessment and quiz
 * components for this instance's client right now: the attribution banner
 * (or per-member list) plus, on the advisor surface, always `sessionMemberId:
 * null` (that field is meaningful only on the client-session mirror).
 */
export function getAnsweringSubjects(instanceId: string) {
  return get<AnsweringSubjectsResponse>(`${BASE}/${instanceId}/answering-subjects`);
}
